import {SilosIcon as SiloIcon} from '@hconnect/uikit/src/common'
import {BarycentricCoordinates, customThemeConstants, LabelStyle} from '@hconnect/uikit/src/lib2'
import {Shuffle, Bolt} from '@mui/icons-material'
import {useTheme} from '@mui/material'
import moment from 'moment-timezone'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import type {OptimizerPriorities} from '../../types'

export const mapOptimizerPrioritiesToBarycentricCoordinates = (
  optimizerPriorities: OptimizerPriorities
): BarycentricCoordinates => [
  optimizerPriorities.switchCostPriority,
  optimizerPriorities.electricityCostPriority,
  optimizerPriorities.siloSlackPriority
]
export const mapBarycentricCoordinatesToOptimizerPriorities = (
  coordinates: BarycentricCoordinates
): OptimizerPriorities => ({
  switchCostPriority: coordinates[0],
  electricityCostPriority: coordinates[1],
  siloSlackPriority: coordinates[2]
})

const {accent2, accent1} = customThemeConstants().palette

export const useOptimizerPrioritiesStyles = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {palette} = useTheme()

  return useMemo(
    () =>
      [
        {
          color: palette.primary.main,
          label: t('optimizer.switchCostPriorityLabel'),
          icon: <Shuffle />
        },
        {color: accent2, label: t('optimizer.electricityCostPriorityLabel'), icon: <Bolt />},
        {
          color: accent1,
          label: t('optimizer.siloSlackPriorityLabel'),
          // custom height to fit the MUI icon size
          icon: <SiloIcon fill={accent1} height={16} />
        }
      ] as [LabelStyle, LabelStyle, LabelStyle],
    [palette, t]
  )
}

export const validateOptimizeFromTime = (t: (key: string) => string) => (value: moment.Moment) => {
  if (!value) return true
  return moment(value, 'HH:mm', true).isValid() || t('error.invalidTime')
}

export const validateOptimizeFromDateTime =
  (t: (key: string) => string, plantNowTime: moment.Moment) => (value: moment.Moment) => {
    if (!value) return true
    if (!moment(value, 'DD/MM/YYYY HH:mm', true).isValid()) {
      return t('error.invalidDate')
    }
    return value.isAfter(plantNowTime) || t('error.dateInPast')
  }
